export default "__VITE_ASSET__BXenwQG5__"